import createIconComponent from './utils/createIconComponent';
import React from 'react';
const TrashCan = createIconComponent({
  height: 22,
  width: 22,
  content: (
    <g>
      <path
        stroke='#003E6B'
        d='M5 4.5h-.53l.03.53L5 5l-.5.03h0l.001.001v.007l.002.026.006.102.023.386.081 1.384c.069 1.148.16 2.685.256 4.241.096 1.557.195 3.133.276 4.36.041.613.078 1.14.108 1.534.029.376.054.666.073.775.068.387.237.778.487 1.083.248.303.623.571 1.096.571h8.182c.477 0 .845-.273 1.088-.574.245-.304.41-.688.491-1.06.025-.115.05-.337.073-.602.025-.28.054-.649.085-1.085.062-.873.134-2.024.21-3.296.083-1.358.17-2.865.254-4.32.073-1.26.144-2.481.207-3.533l.032-.53H5z'
      />
      <path
        stroke='#003E6B'
        d='M7.5 4.5v-2c0-.552.448-1 1-1h5c.552 0 1 .448 1 1v2'
      />
      <rect
        width='19.5'
        height='.5'
        x='1.25'
        y='4.25'
        stroke='#003E6B'
        strokeWidth='.5'
        rx='.25'
      />
      <rect
        width='1'
        height='10'
        fill='#003E6B'
        rx='.5'
        transform='matrix(-1 0 0 1 14 7)'
      />
      <rect width='1' height='10' x='8' y='7' fill='#003E6B' rx='.5' />
    </g>
  ),
});
TrashCan.displayName = 'TrashCan';
export default TrashCan;
